export class UnconfirmedAvailabilityError extends Error {
  constructor(readonly adIds: string[]) {
    super(`Availability could not be confirmed for ${adIds.join(', ')}.`);
  }
}
